import { memo } from 'react';

import { tailwindVariants } from '@air/utils-tailwind';

import { formatShortcutKey } from '~/utils/KeyUtils';

/** Matches Strato `KeyHint`: `rounded border border-gray-04/40 bg-gray-01 px-1 py-px text-10 text-gray-08`. */
const searchCommandShortcutKey = tailwindVariants({
  base: 'rounded-4 border ads:border-default border-gray-4/40 ads:bg-base bg-gray-1 px-1 py-px font-normal ads:text-secondary text-10 text-gray-11',
});

export const SearchCommandShortcutsFooter = memo(() => {
  return (
    <div
      className="flex shrink-0 flex-wrap items-center gap-x-3 gap-y-0.5 ads:border-default border-gray-4 border-t px-4 py-2.5 ads:text-secondary text-10 text-gray-11"
      data-testid="SEARCH_COMMAND_SHORTCUTS_FOOTER"
    >
      <span className="inline-flex items-center gap-1">
        <kbd className={searchCommandShortcutKey()}>{formatShortcutKey('enter')}</kbd>
        search
      </span>
      <span className="inline-flex items-center gap-1">
        <kbd className={searchCommandShortcutKey()}>
          {formatShortcutKey('up')}
          {formatShortcutKey('down')}
        </kbd>
        browse
      </span>
      <span className="inline-flex items-center gap-1">
        <kbd className={searchCommandShortcutKey()}>{formatShortcutKey('esc')}</kbd>
        close
      </span>
    </div>
  );
});

SearchCommandShortcutsFooter.displayName = 'SearchCommandShortcutsFooter';
